export default Object.freeze({
  // Public routes
  prelogin: "/enter",
  login: "/login",
  register: "/register",
  resetPassword: "/reset_password",
  teamMemberWelcome: "/team-member-welcome",
  TeamMemberSignupStep1: "/team-member-signup/step-1",
  TeamMemberSignupStep2: "/team-member-signup/step-2",
  about: "/about",
  contact: "/contact",
  termsConditions: "/all-terms",
  termsUsers: "/terms/users",
  termsBusiness: "/terms/business",
  termsPrivacy: "/terms/privacy",
  termsCookies: "/terms/cookies",
  subscription: "/subscription",
  tryon: "/tryon",
  tokenTagInfo: "/games/token-tag/info",
  // Private routes
  profile: "/profile",
  wardrobe: "/vault",
  store: "/store",
  arts: "/artefacts",
  wearable: "/wearables",
  worlds: "/architecture",
  following: "/collecting",
  spins: "/spins",
  gallery: "/gallery",
  vouchers: "/vouchers",
  shipping: "/shipping",
  os: "/os",
  iot: "/iot",

  viewAsProfile: "/profile/:uid",
  viewAsWardrobe: "/profile/:uid/vault",
  viewAsStore: "/profile/:uid/store",
  viewAsArts: "/profile/:uid/artefacts",
  viewAsWearable: "/profile/:uid/wearables",
  viewAsWorlds: "/profile/:uid/architecture",
  viewAsFollowing: "/profile/:uid/collecting",
  viewAsSpins: "/profile/:uid/spins",
  viewAsGallery: "/profile/:uid/gallery",
  galleryListView: "/profile/:uid/gallery/list",
  viewAsVouchers: "/profile/:uid/vouchers",

  shippingAdress: "/shipping/:uid",

  tokenizedProduct: "/item/:uid",
  wearableProduct: "/wearable/:uid",
  artefactProduct: "/artefact/:uid",
  architectureProduct: "/architecture/:uid",
  spaceObject: "/object/:slug",
  checkoutProduct: "/checkoutProduct/:uid",
  confirmPasson: "/deliveryCheckout/atStore",
  giveback: "/giveback/:ownerUid/:productUid",

  chat: "/inbox",
  dialog: "/inbox/dm/:uid",
  dms: "/dms",
  dmsActive: "/dms/:chatId",
  hubs: "/hubs",
  hubsActive: "/hubs/:hubId",
  submittedPerfectly: "/submitted_perfectly",

  // Public routes
  marketPlace: "https://spin.fashion/explore",
  home: "https://spin.fashion",

  // Edit profile and some times used as profile
  profileModal: "/profile_modal",
});